import { CostOverview } from 'src/app/pages/Booking/Features/Header/CostOverview';
import HeaderLink from 'src/app/pages/Booking/Features/Header/HeaderLink';
import { BookingItem, LinkedBooking } from 'src/app/types/Booking';
import { BookingMacroType } from 'src/types/BookingType';

import { TransportBookingPdfDownloadLink } from '../../../../../../components/Pdf/Booking/Transport/TransportBookingPdfDownloadLink';
import { HeaderAccountName } from '../../../../Features/Header/HeaderAccountName';
import HeaderBookingNumber from '../../../../Features/Header/HeaderBookingNumber';
import HeaderFlags from '../../../../Features/Header/HeaderFlag';
import { HeaderWrapper } from '../../../../Features/Header/HeaderWrapper';

type Props = {
  booking: BookingItem;
  isLoading?: boolean;
  next?: LinkedBooking;
  previous?: LinkedBooking;
};

function TransportHeader({
  booking,
  isLoading,
  next,
  previous
}: Props): JSX.Element {
  return (
    <HeaderWrapper
      type={BookingMacroType.TRANSPORT}
      isLoading={isLoading}
      flags={
        <HeaderFlags
          deliveryMethod={booking.deliveryMethod}
          customerRef={booking.customerRef}
          orderAccountName={booking.orderAccountName}
          isInsured={booking.orderInsurance}
          finalDeliveryDate={booking.orderFinalDeliveryDate}
        />
      }
      downloadPdf={<TransportBookingPdfDownloadLink booking={booking} />}
      costOverview={<CostOverview booking={booking} />}
      bookingNumber={<HeaderBookingNumber booking={booking} />}
      link={
        next || previous ? (
          <HeaderLink previous={previous} next={next} />
        ) : undefined
      }
      accountName={<HeaderAccountName accountName={booking.accountName} />}
    />
  );
}

export default TransportHeader;
